import React, { useEffect, useMemo, useRef, useState } from "react";
import Button from "../../../components/common/ui/Button";
import {
  CheckBoxInput,
  FileInput,
  RadioInput,
  TextAreaInput,
} from "../../../components/common/ui/Inputs";
import { useReactToPrint } from "react-to-print";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../../components/common/table/Table";
import { history } from "../../../_helpers";
import { Link, useLocation } from "react-router-dom";
import {
  masterActions,
  staffRequestAction,
  authActions,
  facilityAction,
} from "../../../_store";
import { Popup } from "../../../components/common/ui/NotificationModal/Popup";
import { showToastNotification } from "../../../components/common/ui/NotificationModal/ToastNotication";
import CustomLoader from "../../../components/common/ui/Loader";
import { publicDefenderRequestFormSchema } from "../../../validation/staffRequestSchema";
import FormHeader from "./FormHeader";
import { StoredProcedures, UserRoleType } from "../../../_helpers/enumerator";
import ExcelExport from "../../../components/common/ui/Export/ExcelExport";
import generateXlsx from "../../../components/common/export/generateXlsx";
import {
  formatDateTimeAMPM,
  getCurrentDate,
  getCurrentTime,
} from "../../../utils/formatTime";
import PdfViewer from "../../../components/common/PdfViewer/PdfViewer";
//import useTranslate from "../../../utils/useTranslation";
import translateText from "../../../_helpers/GoogleTranslator";
import DefenderFormHeader from "./DefenderFormHeader";
import { getStoredValue } from "../../../_helpers/storagehelper";

function PublicDefenderRequestForm() {
  const componentRef = useRef();
  const dispatch = useDispatch();
  const location = useLocation();

  const formID = location?.state ? location?.state?.formID : 0;
  const noticeID = location?.state ? location?.state?.noticeID : 0;
  const formDetails = location?.state ? location?.state?.formDetails : {};
  const RequestFormType = location?.state
    ? location?.state?.RequestFormType
    : 0;

  // const STAFF_REQUEST_ACCESSIBLE_FA = [974];

  const InmateID = location?.state ? location?.state?.InmateID : 0;

  const sourceFrom = location?.state ? location?.state?.sourceFrom : "";
  const MAX_FILE_SIZE = parseInt(process.env.REACT_APP_MAX_FILESIZE, 10);
  const InmateResidentId = location?.state
    ? location?.state?.InmateResidentId
    : 0;

  const oldRequestFormTitle = location?.state
    ? location?.state?.oldRequestFormTitle
    : 0;

  const loggedUser = getStoredValue("user")?.ManagementUserID;

  const [requestFormSubmitted, setRequestFormSubmitted] = useState(false);

  const {
    loadInmateRequestFormList,
    updateRequestFormTypePopupdata,
    updateChangeRequestFormTypeData,
    submitRequestFormInfoResponse,
    requestReview,
    LoadInmateRequestPublicDefenderThreadPostResponse,
    publicDefenderDetailsResponse,
    PublicDefenderThreadRespondResponse,
    publicDefenderRequestFormPayloadData,
    loading,
  } = useSelector((x) => x?.staffRequest);

  // const { facilityDetails } = useSelector((x) => x?.facility);

  const { GetFacilityStaffReqInfoResponse, loading: facilityLoader } =
    useSelector((x) => x?.facility);

  const facilityCode = useSelector((x) => x?.auth?.commonFacilityCode);
  const { ReplyMode } = useSelector((x) => x.dropdownOptions);
  const { user, commonFacilityCode } = useSelector((x) => x.auth);

  //const { translatedMessages, translateMessages } = useTranslate();

  const managementUserID = user?.ManagementUserID;
  const userRoleID = user?.UserRoleID;
  const [facilityName, setFacilityName] = useState("");
  const [formType, setFormType] = useState(1);
  const [showReplyModal, setShowReplyModal] = useState(false);
  const [requestFormTypePopup, setRequestFormTypePopUp] = useState({
    requestFormTypeID: RequestFormType,
    newRequestFormTypeId: 0,
    inmateResidentId: InmateResidentId,
    facilityCode: facilityCode,
  });

  const [updateRequestFormType, setUpdateRequestFormType] = useState({
    facilityID: facilityCode,
    oldRequestFormTypeID: RequestFormType,
    newRequestFormTypeID: requestFormTypePopup?.newRequestFormTypeId,
    requestForumThreadID: formID,
    managementUserID: loggedUser,
    oldRequestFormTitle: oldRequestFormTitle,
    newRequestFormTitle: "",
  });

  const [requestFormTable, setRequestFormTable] = useState({
    formID: formID,
    pageNo: 1,
    rowCountPerPage: 10,
  });

  const [errorMessage, setErrorMessage] = useState({});
  const [pdfdata, setpdfdata] = useState(null);

  // const [requestFormData, setRequestFormData] = useState({
  //   // folderPath: "",
  //   // filename: "",
  //   // file: "",
  //   // requestForumThreadID: "",
  //   // facilityID: facilityCode,
  //   // facilityCode: "",
  //   // inmatesId: "",
  //   // managementUserID: loggedUser,
  //   // activeStatus: 0,
  //   // noticesTitle: "",
  //   // pdfAttachPath: "",
  //   // postType: 1,

  //   pRequestFormTypeID: noticeID,
  //   facilityID: facilityCode,
  //   inmatesId: InmateID,
  //   managementUserID: loggedUser,
  //   postByInmate: 0,
  //   postByMuUser: 1,
  //   activeStatus: 0,
  //   pdFormPostBody: "",
  //   pdfAttachPath: "",
  //   postType: 1,
  // });

  const [selectLang, setselectLang] = useState("");
  const [updateRequestColumn, setUpdateRequestColumn] = useState([]);
  const [updatePostByColumn, setUpdatePostByColumn] = useState([]);
  const [transLoader, setTransLoader] = useState(false);

  const prevFacilityCodeRef = useRef(facilityCode);

  //load facility drop down
  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    )
      .then((data) => {
        const facilityList = data?.payload;
        const facilityName = facilityList?.find(
          (x) => x?.value === facilityCode
        )?.label;
        setFacilityName(facilityName);
      })
      .catch(() => {
        setFacilityName("");
      });
  }, []);

  useEffect(() => {
    if (prevFacilityCodeRef.current !== facilityCode) {
      history.navigate(sourceFrom);
    }
  }, [facilityCode]);

  useEffect(() => {
    // dispatch(
    //   facilityAction?.GetFacilityDetailsByID({
    //     facilityID: facilityCode,
    //   })
    // );

    dispatch(
      facilityAction?.GetFacilityStaffReqInfo({
        facilityID: facilityCode,
      })
    );
  }, []);

  useEffect(() => {
    if (noticeID && managementUserID && facilityCode) {
      getRequestFormDetails();
      getFormThreadListForTable();
    }
    if (
      publicDefenderDetailsResponse?.IsAssignToPDUser === 1 &&
      publicDefenderDetailsResponse?.PDStaffAcceptAssignReqest === 1 &&
      publicDefenderDetailsResponse?.PDStaffRejectAssignReqest === 0
    ) {
      getFormThreadListForTable();
    }
  }, [
    location?.state?.formID,
    requestFormTable?.pageNo,
    requestFormTable?.rowCountPerPage,
    noticeID,
    managementUserID,
    facilityCode,
  ]);

  useEffect(() => {
    switch (PublicDefenderThreadRespondResponse?.IsSucceed) {
      case 1:
        showToastNotification("Form submitted successfully", "success");
        dispatch(
          authActions?.ManagementUserActivityLog({
            ManagementUserID: user?.ManagementUserID,
            facilityID: commonFacilityCode ? commonFacilityCode : 0,
            ProcedureName: StoredProcedures?.ChangedFormType,
            UserAction: `UspRequestPublicDefenderThreadRespond ( MG User Responded to Inmate Request ( PRequestFormTypeID - ${noticeID} )`,
          })
        );

        dispatch(
          staffRequestAction?.UpdateMURequestRead({
            requestID: noticeID,
            requestFormTypeID: RequestFormType,
            facilityID: commonFacilityCode,
            createdBy: managementUserID,
          })
        );
        //update notification count
        dispatch(
          masterActions.GetLoadNotificationAlert({
            ManagementUserID: managementUserID,
            FacilityID: facilityCode,
          })
        );

        getFormThreadListForTable();
        getRequestFormDetails();
        const searchData = { ...publicDefenderRequestFormPayloadData };
        searchData.pdFormPostBody = "";
        searchData.postType = 1;
        searchData.activeStatus = 0;
        dispatch(
          staffRequestAction?.updatePublicDefenderRequestFormPayload(searchData)
        );
        dispatch(staffRequestAction?.resetPublicDefenderRequestFormPayload());
        setRequestFormSubmitted(true);
        dispatch(staffRequestAction?.resetForm());
        // setRequestFormData(searchData);
        break;

      case -1:
        showToastNotification("Operation Failed", "error");
        dispatch(staffRequestAction?.resetForm());
        break;

      case -2:
        showToastNotification("Public Defender Form not exist", "error");
        dispatch(staffRequestAction?.resetForm());
        break;

      case -3:
        showToastNotification(
          "Public Defender Form not assigned to public defender user or improper public defender user post request",
          "error"
        );
        dispatch(staffRequestAction?.resetForm());
        break;

      case -4:
        showToastNotification("Form post is wrong value", "error");
        dispatch(staffRequestAction?.resetForm());
        break;

      case -5:
        showToastNotification("Post body empty or PDF Path empty", "error");
        dispatch(staffRequestAction?.resetForm());
        break;

      default:
        break;
    }
  }, [PublicDefenderThreadRespondResponse]);

  const getRequestFormDetails = () => {
    dispatch(
      staffRequestAction.publicDefenderDetails({
        formId: noticeID,
        ManagementUserID: managementUserID,
        FacilityCode: facilityCode,
      })
    );
  };

  const getFormThreadListForTable = () => {
    dispatch(
      staffRequestAction.LoadInmateRequestPublicDefenderThreadPost({
        noticesId: noticeID,
        isInmate: 0,
        isMGUser: 1,
        managementUserID: managementUserID,
        RowCountPerPage: 10,
        PageNo: 1,
      })
    )
      .then((result) => {
        if (result?.payload) {
          handleTranslate(selectLang, result?.payload);
        }
      })
      .catch((err) => { });
  };

  useEffect(() => {
    switch (updateRequestFormTypePopupdata?.IsSucceed) {
      case 1:
        Popup({
          title: "Message",
          text: `Your chosen form is not allow to create the new request by 
          Inmates but your selected form is allow to create the New request 
          by Inmates. If you want to proceed, Admin  is not allow to create 
          the New request. Are you sure, you want to reassign the selected 
          form to chosen form?`,
          icon: "info",
          confirmButtonText: "YES",
          cancelButtonText: "NO",
          onConfirm: () =>
            dispatch(
              staffRequestAction.updateChangeRequestFormType(
                updateRequestFormType
              )
            ),
        });
        dispatch(staffRequestAction?.resetForm());
        break;
      case 2:
        Popup({
          title: "Message",
          text: `Your chosen form limit is Zero. 
          If you want to proceed, Inmates not allow to create this request form. 
          Admin only allow to create the new request.
          Are you sure, you want to reassign the selected form to chosen form ?`,
          icon: "info",
          confirmButtonText: "YES",
          cancelButtonText: "NO",
          onConfirm: () =>
            dispatch(
              staffRequestAction.updateChangeRequestFormType(
                updateRequestFormType
              )
            ),
        });
        dispatch(staffRequestAction?.resetForm());
        break;
      case 0:
        Popup({
          title: "Message",
          text: `Are you sure you want to Re-assign this Forum to another Forum type?`,
          icon: "info",
          confirmButtonText: "YES",
          cancelButtonText: "NO",
          onConfirm: () =>
            dispatch(
              staffRequestAction.updateChangeRequestFormType(
                updateRequestFormType
              )
            ),
        });
        dispatch(staffRequestAction?.resetForm());
        break;

      default:
        break;
    }
  }, [updateRequestFormTypePopupdata]);

  useEffect(() => {
    if (updateChangeRequestFormTypeData?.IsSucceed > 0) {
      // Insert Management User Activity Log
      dispatch(
        authActions?.ManagementUserActivityLog({
          ManagementUserID: user?.ManagementUserID,
          facilityID: commonFacilityCode ? commonFacilityCode : 0,
          ProcedureName: StoredProcedures?.ChangedFormType,
          UserAction: `UspMoveForumFormToNewForum ( RequestForumThreadID - ${formID} )`,
        })
      );
      showToastNotification("Form Reassigned Successfully.", "success");
      history?.navigate("/Admin/StaffRequestList");
      dispatch(staffRequestAction?.resetForm());
    }
    if (updateChangeRequestFormTypeData?.IsSucceed === -1) {
      showToastNotification("'Forum thread not found.", "error");
      history?.navigate("/Admin/StaffRequestList");
      dispatch(staffRequestAction?.resetForm());
    }
  }, [updateChangeRequestFormTypeData]);

  useEffect(() => {
    switch (submitRequestFormInfoResponse?.IsSucceed) {
      case 1:
        dispatch(
          authActions?.ManagementUserActivityLog({
            ManagementUserID: user?.ManagementUserID,
            facilityID: commonFacilityCode ? commonFacilityCode : 0,
            ProcedureName: StoredProcedures?.RequestPublicDefenderThreadRespond,
            UserAction: `MG User Responded to Inmate Request ( PRequestFormTypeID -${formID})`,
          })
        );
        showToastNotification("Form Submitted Successfully.", "success");
        dispatch(staffRequestAction?.resetForm());
        const searchData = { ...publicDefenderRequestFormPayloadData };
        searchData.pdFormPostBody = "";
        searchData.pdfAttachPath = "";
        searchData.activeStatus = 0;
        dispatch(
          staffRequestAction?.updatePublicDefenderRequestFormPayload(searchData)
        );
        // setRequestFormData(searchData);
        getRequestFormDetails();
        getFormThreadListForTable();
        break;

      case -2:
        showToastNotification("Not Exist This Thread.", "error");
        break;

      case -1:
        showToastNotification("Operation Failed", "error");
        break;

      default:
        break;
    }
  }, [submitRequestFormInfoResponse]);

  const handlePrints = useReactToPrint({
    pageStyle: `@media print {
      @page {
       size: A4 portrait;
        margin: 2 !important;
         padding: 2 !important;
      }
body {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      * {
        
        font-size: 16px !important;
      }

      table, th, td {
        border: 2px solid black !important;
      }

      .print-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        break-inside: avoid;
        page-break-inside: avoid;
      }

      .print-date {
        position: absolute;
        top: 10px;
        right: 20px;
        font-size: 14px;
        font-weight: bold;
      }
    }
  `,

    content: () => componentRef.current,
    onBeforeGetContent: () => { },
  });

  function separatePathAndFileName(filePath) {
    // Find the last index of the '/' character
    const lastSlashIndex = filePath.lastIndexOf('/');

    // Extract folder path and file name

    let folderPath = filePath.substring(0, lastSlashIndex + 1);
    if (process.env.REACT_APP_FOLDER_PATH && process.env.REACT_APP_FOLDER_PATH.trim() !== "") {
      folderPath = `${process.env.REACT_APP_FOLDER_PATH}${filePath.substring(0, lastSlashIndex + 1)}`;
    }

    var filename = filePath.substring(lastSlashIndex + 1);

    return { folderPath, filename };
  }

  const handleDownloadPDF = (e, row) => {
    e?.preventDefault();
    const { folderPath, filename } = separatePathAndFileName(row?.PdfDocAttachPath);

    // const splitFolderPath = row?.PdfDocAttachPath?.split("/");
    // const folderPath =
    //   splitFolderPath[1] + "/" + splitFolderPath[2] + "/" + splitFolderPath[3];
    // const fileName = splitFolderPath[4];
    dispatch(
      staffRequestAction?.DownLoadFile({
        folderPath: folderPath,
        filename: filename,
      })
    )
      .then((result) => {
        setpdfdata(result?.payload);
      })
      .catch((err) => {
        showToastNotification("Failed to view PDF", "error");
      });
  };

  const exportRequestForm = async () => {
    let generateExcelColumns = ["Request", "Posted By", "Send Date time"];
    const updateTotalRows = {
      ...requestFormTable,
      rowCountPerPage: LoadInmateRequestPublicDefenderThreadPostResponse?.TotalRecordCount,
      exportExcel: true,
      pageNo: 1,
    };

    try {
      const result = await dispatch(
        staffRequestAction?.loadInmateRequestForumThreadList(updateTotalRows)
      );

      const dataList = result?.payload?.DataList || [];

      const exportData = await Promise.all(
        dataList.map(async (obj) => {
          const translatedBody =
            obj?.IsAttachDocPDF === 1 && obj?.IsPostText === 1
              ? (selectLang == "en" || selectLang == "es" ? (await translateText(obj.ForumPostBody, selectLang)) : obj.ForumPostBody) +
              " (Replied as PDF)"
              : obj?.IsAttachDocPDF === 1
                ? "(Replied as PDF)"
                : (selectLang == "en" || selectLang == "es" ? await translateText(obj.ForumPostBody, selectLang) : obj.ForumPostBody);
          const translatedPostedBy = (selectLang == "en" || selectLang == "es" ? await translateText(
            obj.ForumThreadPostBy,
            selectLang
          ) : obj.ForumThreadPostBy);
          return {
            Request: translatedBody,
            "Posted By": translatedPostedBy,
            "Send Date time": formatDateTimeAMPM(obj.ReqPostSendDate),
          };
        })
      );

      generateXlsx(exportData, generateExcelColumns, "Forum_List");
    } catch (error) {
      showToastNotification("Error exporting data", "error");
    }
  };

  const column = useMemo(
    () => [
      {
        name: "Request",
        width: "350px",
        selector: (row) => row.request,
        cell: (row, i) =>
          row.PostByInmate === 1 ? (
            <div div className="d-flex flex-column gap-2 ">
              {/* <div className="d-flex flex-wrap gap-2">
                <i
                  className="fa-solid fa-reply inmate-replied fs-3"
                  aria-hidden="true"
                  title="Inmate Replied"
                ></i>
                {row?.ForumPostBody}
              </div> */}
              <div className="d-flex gap-2">
                <i
                  className="fa-solid fa-reply inmate-replied fs-3"
                  aria-hidden="true"
                  title="Inmate Replied"
                ></i>
                <div
                  className="pre-wrap-text"
                  dangerouslySetInnerHTML={{
                    __html:
                      updateRequestColumn?.length > 0
                        ? updateRequestColumn[i]
                        : showmessagecontent(row?.ForumPostBody),
                  }}
                ></div>
              </div>
              {row?.PdfDocAttachPath && (
                <div className="d-flex align-items-center gap-2">
                  {/* <Link
                    className="btn button-success d-block  btn-lg w-inherit cursor-pointer"
                    onClick={(e) => handleDownloadPDF(e, row)}
                  >
                    View PDF
                  </Link> */}
                  <Link
                    className="btn button-success btn-lg w-inherit cursor-pointer"
                    onClick={(e) => handleDownloadPDF(e, row)}
                  >
                    <i class="fa-solid fa-file-pdf me-2"></i>
                    View PDF
                  </Link>
                </div>
              )}
            </div>
          ) : (
            // Example "else if" condition
            <div div className="d-flex flex-wrap gap-2 align-items-start">
              {/* <div className="d-flex flex-wrap gap-2">
                <i
                  className="fa-solid fa-user-shield admin-replied fs-3"
                  aria-hidden="true"
                  title="Admin Replied"
                />
                {row?.ForumPostBody}
              </div> */}
              <div className="d-flex  gap-2">
                <i
                  className="fa-solid fa-user-shield admin-replied fs-3"
                  aria-hidden="true"
                  title="Admin Replied"
                />
                <div
                  className="pre-wrap-text"
                  dangerouslySetInnerHTML={{
                    __html:
                      updateRequestColumn?.length > 0
                        ? updateRequestColumn[i]
                        : showmessagecontent(row?.ForumPostBody),
                  }}
                ></div>
              </div>
              {row?.PdfDocAttachPath && (
                // <Link
                //   className="btn button-success d-block  btn-lg w-inherit cursor-pointer"
                //   onClick={(e) => handleDownloadPDF(e, row)}
                // >
                //   View PDF
                // </Link>
                <Link
                  className="btn button-success btn-lg w-inherit cursor-pointer"
                  onClick={(e) => handleDownloadPDF(e, row)}
                >
                  <i class="fa-solid fa-file-pdf me-2"></i>
                  View PDF
                </Link>
              )}
            </div>
          ),
        sortable: false,
      },

      {
        name: "Posted By",
        selector: (row) => row.ForumThreadPostBy,
        cell: (row, i) => (
          <div
            className="d-flex flex-wrap gap-2 pre-wrap-text"
            dangerouslySetInnerHTML={{
              __html:
                updatePostByColumn?.length > 0
                  ? updatePostByColumn[i]
                  : showmessagecontent(row?.ForumThreadPostBy),
            }}
          ></div>
        ),
        sortable: false,
      },
      {
        name: "Sent Date Time",
        selector: (row) => formatDateTimeAMPM(row.ReqPostSendDate),
        sortable: false,
      },
    ],
    [
      updateRequestColumn,
      updatePostByColumn,
      LoadInmateRequestPublicDefenderThreadPostResponse?.DataList,
    ]
  );

  const handleRowPerPage = (page) => {
    setRequestFormTable((prevState) => ({
      ...prevState,
      rowCountPerPage: page,
    }));
  };

  const showmessagecontent = (Value) => {
    const highlightedMessageContent = `<span >${Value}</span>`;
    return highlightedMessageContent;
  };

  useEffect(() => {
    handleTranslate(selectLang)
  }, [selectLang])

  const handleTranslate = async (
    language,
    data = LoadInmateRequestPublicDefenderThreadPostResponse
  ) => {
    setselectLang(language);
    setTransLoader(true);
    const request = data?.DataList?.map((msg) => msg?.ForumPostBody);
    const postBy = data?.DataList?.map((msg) => msg?.ForumThreadPostBy);
    // const translatedRequest = await translateText(request, language);
    // const translatedPostBy = await translateText(postBy, language);

    const translatedRequest =
      language === "es" || language === "en" ? await translateText(request, language) : request;
    const translatedPostBy =
      language === "es" || language === "en" ? await translateText(postBy, language) : postBy;

    const requestColumn = translatedRequest?.map((text) => {
      return `<span>${text}</span>`;
    });
    const posyByColumn = translatedPostBy?.map((text) => {
      return `<span>${text}</span>`;
    });
    setUpdateRequestColumn(requestColumn);
    setUpdatePostByColumn(posyByColumn);
    setTransLoader(false);
  };

  const handlePageChange = (page) => {
    setRequestFormTable((prevState) => ({
      ...prevState,
      pageNo: page,
    }));
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e?.target;
    const errorList = { ...errorMessage };
    delete errorList[name];
    setErrorMessage(errorList);

    if (type === "file" && files?.length === 0) {
      setErrorMessage((prev) => ({
        ...prev,
        [name]: "Please upload PDF Document.",
      }));
      const data = { ...publicDefenderRequestFormPayloadData };
      data["file"] = "";
      data["fileType"] = "";
      data["fileSize"] = 0;
      dispatch(
        staffRequestAction?.updatePublicDefenderRequestFormPayload(data)
      );
      // setRequestFormData(data);
      return;
    }

    if (type === "file" && files?.length > 0) {
      const fileType = files?.[0]?.type;
      const fileSize = files?.[0]?.size;
      if (fileSize > MAX_FILE_SIZE) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: "File size should not exceed 20MB.",
        }));
      }
      if (fileType !== "application/pdf") {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: "Please select PDF Document.",
        }));
        const data = { ...publicDefenderRequestFormPayloadData };
        data["file"] = "";
        data["fileType"] = fileType;
        data["fileSize"] = 0;
        dispatch(
          staffRequestAction?.updatePublicDefenderRequestFormPayload(data)
        );
        // setRequestFormData(data);
        return;
      }
      // setErrorMessage({});
      const reader = new FileReader();
      reader.onloadend = () => {
        let formData = { ...publicDefenderRequestFormPayloadData };
        const fileName = files[0]?.name;
        const lastIndex = fileName?.lastIndexOf(".");
        const removedExtensionTxt = [...fileName]
          .splice(0, lastIndex)
          .toString();
        const removeWhitSpace = removedExtensionTxt.replace(
          /[+\-\/,?*:;<>@#$%^&!~\s]/g,
          ""
        );
        const removedExtraTxt = [...removeWhitSpace].splice(0, 100).join(""); //retutn only 100 characters
        const currentDate = getCurrentDate()?.split("/").join("");
        const currentTime = getCurrentTime().split(":").join("");
        const now = new Date();
        // const timestamp = now.getFullYear().toString() +
        //   String(now.getMonth() + 1).padStart(2, "0") +
        //   String(now.getDate()).padStart(2, "0") +
        //   String(now.getHours()).padStart(2, "0") +
        //   String(now.getMinutes()).padStart(2, "0") +
        //   String(now.getSeconds()).padStart(2, "0");
        formData["file"] = reader.result.split(",")[1];
        formData["filename"] = removedExtraTxt;
        // formData["facilityCode"] = facilityName;
        formData["facilityCode"] =
          GetFacilityStaffReqInfoResponse?.FacilityName;
        formData["fileType"] = files?.[0]?.type;
        formData["fileSize"] = files?.[0]?.size;
        dispatch(
          staffRequestAction?.updatePublicDefenderRequestFormPayload(formData)
        );
        // setRequestFormData(formData);
      };
      reader.readAsDataURL(files[0]);
    }
    const formData = { ...publicDefenderRequestFormPayloadData };
    if (type === "radio") {
      setErrorMessage({});
      formData[name] = parseInt(value);
      formData["pdFormPostBody"] = "";
      formData["file"] = "";
      formData["filename"] = "";
      formData["fileType"] = "";
      formData["fileSize"] = 0;
      const fileInput = document.getElementById("fileInput");
      if (fileInput) {
        fileInput.value = "";
      }
    }

    if (type === "checkbox") {
      formData[name] = checked ? 1 : 0;
    }

    if (type === "textarea") {
      if (/^\s/.test(value)) return;
      formData[name] = value;
    }
    // setRequestFormData(formData);
    dispatch(
      staffRequestAction?.updatePublicDefenderRequestFormPayload(formData)
    );
  };

  // const handleValidation = (e, name) => {
  // const { error } = publicDefenderRequestFormSchema(
  //   publicDefenderRequestFormPayloadData
  // );
  //   const errorList = { ...errorMessage };
  //   if (error?.details) {
  //     const fieldError = error.details.find((e) => e.path.toString() === name);
  //     setErrorMessage((prev) => ({
  //       ...prev,
  //       [name]: fieldError ? fieldError.message : "", // Set the error message if exists, else clear it
  //     }));
  //     const element = document.querySelector(`[name="${name}"]`);
  //     if (element) {
  //       if (fieldError) {
  //         element.classList.add("input-error");
  //       } else {
  //         element.classList.remove("input-error");
  //       }
  //     }
  //   } else {
  //     delete errorList[name];
  //     setErrorMessage(errorList);
  //     const element = document.querySelector(`[name="${name}"]`);
  //     if (element) {
  //       element.classList.remove("input-error");
  //     }
  //     // submitRequestFormInfo();
  //   }
  // };

  // const handleValidation = (e, name) => {
  //   const requestData = { ...publicDefenderRequestFormPayloadData };
  //   const file = { type: requestData?.fileType, size: requestData?.fileSize };
  //   requestData.file = file;
  //   const { error } = publicDefenderRequestFormSchema(requestData);
  //   if (error?.details) {
  //     // error?.details?.map((e) => {
  //     //   const { path } = e;
  //     //   setErrorMessage((prev) => ({
  //     //     ...prev,
  //     //     [path[0]]: e?.message,
  //     //   }));
  //     // });
  //     const fieldError = error.details.find((e) => e.path.toString() === name);
  //     setErrorMessage((prev) => ({
  //       ...prev,
  //       [name]: fieldError ? fieldError.message : "",
  //     }));
  //     return;
  //   }
  //   const fieldError = error?.details?.find(
  //     (e) => e?.path?.toString() === name
  //   );
  //   const element = document.querySelector(`[name="${name}"]`);
  //   if (element) {
  //     if (fieldError) {
  //       element.classList.add("input-error");
  //     } else {
  //       element.classList.remove("input-error");
  //     }
  //   }
  // };

  const handleValidation = (e, name) => {
    const requestData = { ...publicDefenderRequestFormPayloadData };
    const file = { type: requestData?.fileType, size: requestData?.fileSize };
    requestData.file = file;
    const { error } = publicDefenderRequestFormSchema(requestData);
    if (error?.details) {
      const fieldError = error.details.find((e) => e.path.toString() === name);
      if (fieldError && Object?.keys(fieldError)?.length > 0) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: fieldError ? fieldError.message : "",
        }));
      }
      return;
    }
    const fieldError = error?.details?.find(
      (e) => e?.path?.toString() === name
    );
    const element = document.querySelector(`[name="${name}"]`);
    if (element) {
      if (fieldError) {
        element.classList.add("input-error");
      } else {
        element.classList.remove("input-error");
      }
    }
  };
  const handleRequestFormTypeChange = () => {
    setFormType(formType === 1 ? 2 : 1);
    if (formType === 1) {
      dispatch(
        staffRequestAction?.getFormTypeList({
          formID: RequestFormType,
          FacilityCode: facilityCode,
        })
      );
    }
  };

  // const handleFormTypeChange = (e) => {
  //   setRequestFormTypePopUp({
  //     ...requestFormTypePopup,
  //     newRequestFormTypeId: e?.value,
  //   });
  //   setUpdateRequestFormType({
  //     ...updateRequestFormType,
  //     newRequestFormTitle: e?.label,
  //     newRequestFormTypeID: e?.value,
  //   });
  // };

  // const handleUpdateFormTypePopup = () => {
  //   dispatch(
  //     staffRequestAction?.updateRequestFormTypePopup(requestFormTypePopup)
  //   );
  // };

  const submitRequestFormInfo = () => {
    if (
      userRoleID === UserRoleType?.PublicDefender ||
      userRoleID === UserRoleType?.PublicDefenderAdmin
    ) {
      const requestData = { ...publicDefenderRequestFormPayloadData };
      const file = { type: requestData?.fileType, size: requestData?.fileSize };
      requestData.file = file;
      if (requestData?.activeStatus != 1) {
        const { error } = publicDefenderRequestFormSchema(requestData);
        setErrorMessage({});

        if (error?.details) {
          error?.details?.map((e) => {
            const { path } = e;
            setErrorMessage((prev) => ({
              ...prev,
              [path[0]]: e?.message,
            }));
          });
          return;
        }
        if (Object?.keys(errorMessage)?.length > 0) return;
      }

      const payload = { ...publicDefenderRequestFormPayloadData };
      payload.inmatesId = InmateID;
      payload.pRequestFormTypeID = formID;
      payload.facilityID = facilityCode;
      payload.managementUserID = managementUserID;
      dispatch(staffRequestAction?.PublicDefenderThreadRespond(payload));
      dispatch(
        staffRequestAction?.updatePublicDefenderRequestFormPayload(payload)
      );
    }
  };

  const handleFormReset = () => {
    dispatch(staffRequestAction?.resetPublicDefenderRequestFormPayload());
    setErrorMessage({});
    // setRequestFormData({
    //   ...publicDefenderRequestFormPayloadData,
    //   pdFormPostBody: "",
    //   postType: 1,
    //   activeStatus: 0,
    // });
  };

  if (loading || facilityLoader || transLoader) return <CustomLoader />;

  return (
    <>
      <div className="card shadow-sm b-r-all  p-4 border border-dark-grey mt-3 me-3  w-100">
        {pdfdata && (
          <div className="d-flex flex-wrap justify-content-end gap-3">
            <Button
              label="Back"
              type="button"
              icon={"fa-solid fa-angle-left"}
              status="primary"
              onClick={() => {
                setpdfdata(null);
              }}
            />
          </div>
        )}
        {pdfdata ? (
          <PdfViewer data={`data:application/pdf;base64,${pdfdata}`} />
        ) : (
          <div>
            <DefenderFormHeader
              requestReview={requestReview}
              list={formDetails}
              handlePrints={handlePrints}
              errorMessage={errorMessage}
              setErrorMessage={setErrorMessage}
              requestFormSubmitted={requestFormSubmitted}
              setRequestFormSubmitted={setRequestFormSubmitted}
            />

            <div className="request-remedy-form">
              <div>
                <div ref={componentRef}>
                  <div className="d-flex flex-wrap align-items-center profile-row mb-4">
                    <div className="d-flex req-header-img">
                      {GetFacilityStaffReqInfoResponse?.LogoFile && (
                        <img
                          src={
                            "data:image/png;base64," +
                            GetFacilityStaffReqInfoResponse?.LogoFile
                          }
                          alt="facility-logo"
                          className="req-img"
                        />
                      )}
                    </div>
                    <div className="justify-content-center align-items-center req-header-title">
                      <h3 className="text-color py-2 text-center">
                        <span className="label-red req-text">
                          {GetFacilityStaffReqInfoResponse?.FacilityName?.toUpperCase()}
                        </span>
                      </h3>
                    </div>
                  </div>
                  <h4
                    className="request-form-header text-color mt-4"
                    style={{ cursor: "pointer" }}
                  >
                    <i className="fa-solid fa-circle-info me-2"></i> PUBLIC
                    DEFENDER FORM
                  </h4>

                  <div
                    ref={componentRef}
                    className="m-1 row border-bottom-1 request-form-card details-legal"
                  >
                    <h4
                      className="request-form-header text-color mt-4"
                      style={{ cursor: "pointer" }}
                    >
                      <i className="fa-solid fa-circle-info me-2"></i> REQUEST
                      INFO
                    </h4>
                    <div className="row ">
                      {[
                        {
                          label: "Title",
                          value:
                            publicDefenderDetailsResponse?.ForumThreadTitle,
                        },
                        {
                          label: "Inmate ID",
                          value:
                            publicDefenderDetailsResponse?.InmateResidentId,
                        },
                        {
                          label: "Inmate Name",
                          value: publicDefenderDetailsResponse?.InmateFullName,
                        },
                        {
                          label: "Created On",
                          value:
                            publicDefenderDetailsResponse?.RequestCreateDate,
                          // publicDefenderDetailsResponse?.IsCreatedByMuUser ===
                          // 1
                          //   ? publicDefenderDetailsResponse?.MuUserFullName
                          //     ? publicDefenderDetailsResponse?.MuUserFullName
                          //     : "-"
                          //   : publicDefenderDetailsResponse?.InmateFullName,
                        },
                        {
                          label: "POD",
                          value: publicDefenderDetailsResponse?.PodCode
                            ? publicDefenderDetailsResponse?.PodCode
                            : "-",
                        },

                        // {
                        //   label: "PD Conversation",
                        //   value: publicDefenderDetailsResponse?.PDConversation
                        //     ? publicDefenderDetailsResponse?.PDConversation
                        //     : "-",
                        // },

                        // {
                        //   label: "Assigned By",
                        //   value: publicDefenderDetailsResponse?.PodCode
                        //     ? publicDefenderDetailsResponse?.PodCode
                        //     : "-",
                        // },

                        // {
                        //   label: "Assigned Staff",
                        //   value: publicDefenderDetailsResponse?.PodCode
                        //     ? publicDefenderDetailsResponse?.PodCode
                        //     : "-",
                        // },
                      ].map((item, index) => (
                        <div key={index} className="col-sm-12 col-md-4">
                          <div className="user-information d-flex flex-wrap align-items-center">
                            <div className="fs-5 p-2  value-info">
                              {item.label}
                            </div>
                            <div className="p-1">:</div>
                            <div className="fs-5 p-2 text-start fw-bold value-text">
                              {item.value || "-"}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {showReplyModal && (
                    <div className="mt-3">
                      <Button
                        label="Change Request Form Type"
                        status="btn-label"
                        type="button"
                        icon={"fa-solid fa-arrows-rotate"}
                        onClick={() => handleRequestFormTypeChange(formType)}
                        title="Change Request Form Type"
                      />
                    </div>
                  )}

                  {/* {formType === 1 ? ( */}
                  <div>
                    {publicDefenderDetailsResponse?.PDStaffAcceptAssignReqest ===
                      1 &&
                      publicDefenderDetailsResponse?.RequestCurrentStatus !==
                      "Closed" &&
                      publicDefenderDetailsResponse?.IsAssignToPDUser === 1 &&
                      publicDefenderDetailsResponse?.PDStaffRejectAssignReqest ===
                      0 && (
                        <>
                          <div className="details-legal d-flex flex-wrap  border-0">
                            <span className="mb-0 request-form-label">
                              Reply Mode
                            </span>
                            <RadioInput
                              name="postType"
                              id="postType"
                              options={ReplyMode}
                              handleChange={(e) => handleChange(e)}
                              selectedValue={
                                publicDefenderRequestFormPayloadData?.postType
                              }
                            />
                          </div>
                          <div className="details-legal">
                            {(publicDefenderRequestFormPayloadData?.postType ===
                              1 ||
                              publicDefenderRequestFormPayloadData?.postType ===
                              3) && (
                                <TextAreaInput
                                  placeholder="Enter Your Description"
                                  name="pdFormPostBody"
                                  handleChange={(e) => handleChange(e)}
                                  value={
                                    publicDefenderRequestFormPayloadData?.pdFormPostBody ||
                                    ""
                                  }
                                  errorMessage={errorMessage}
                                  handleBlur={(e) => {
                                    handleValidation(e, "pdFormPostBody");
                                  }}
                                  maxLength={2000}
                                />
                              )}
                            {(publicDefenderRequestFormPayloadData?.postType ===
                              2 ||
                              publicDefenderRequestFormPayloadData?.postType ===
                              3) && (
                                <FileInput
                                  acceptFormat=".pdf"
                                  name="file"
                                  id="fileInput"
                                  handleFileChange={(e) => handleChange(e)}
                                  errorMessage={errorMessage}
                                />
                              )}
                          </div>
                          <div className="details-legal border-0">
                            <CheckBoxInput
                              name="activeStatus"
                              id="activeStatus"
                              label="Close"
                              handleClick={(e) => handleChange(e)}
                              checked={
                                publicDefenderRequestFormPayloadData?.activeStatus
                              }
                            />
                          </div>
                          <div className="pb-3 gap-3 d-flex flex-wrap justify-content-start align-items-center">
                            <Button
                              label="Submit"
                              status="success"
                              icon={"fa-solid fa-floppy-disk"}
                              type="button"
                              onClick={() => submitRequestFormInfo()}
                              title={"Submit"}
                            />
                            <Button
                              label="Reset"
                              title="Reset"
                              icon={"fa-solid fa-rotate-right"}
                              status="secondary"
                              type="button"
                              onClick={() => handleFormReset()}
                            />
                          </div>
                        </>
                      )}

                    <div className="m-3  d-flex flex-wrap mobile-left align-items-center gap-3">
                      <Button
                        label="Traducir al español"
                        title="Traducir al español"
                        status="btn-label"
                        type="button"
                        className={"w-max"}
                        icon={"language"}
                        onClick={() => setselectLang("es")}
                      />

                      <Button
                        label="Translate to English"
                        title="Translate to English"
                        status="btn-label"
                        type="button"
                        className={"w-max"}
                        icon={"globe"}
                        onClick={() => setselectLang("en")}
                      />
                      <Button
                        label="Reset"
                        title="Reset"
                        icon={"fa-solid fa-rotate-right"}
                        status="btn-label"
                        type="button"
                        onClick={() => setselectLang("")}
                      />
                      <ExcelExport
                        variant="soft-gray"
                        handleExcelExport={exportRequestForm}
                      />
                    </div>

                    <Table
                      columns={column}
                      data={
                        LoadInmateRequestPublicDefenderThreadPostResponse?.DataList
                      }
                      pagination
                      onChangeRowsPerPage={handleRowPerPage}
                      onChangePage={handlePageChange}
                      totalRowCount={
                        LoadInmateRequestPublicDefenderThreadPostResponse?.TotalRecordCount
                      }
                      currentPage={requestFormTable?.pageNo}
                      paginationPerPage={requestFormTable.rowCountPerPage}
                    />
                  </div>
                  {/* ) : (
                  <div className="details-legal">
                    <SelectInput
                      cName={"w-50"}
                      options={formTypeListDropDown}
                      handleChange={(e) => handleFormTypeChange(e)}
                      label="Change To Form Type"
                    />
                    <div className="pt-3 gap-3 d-flex flex-wrap justify-content-start align-items-center">
                      <Button
                        label="Update"
                        title="Update"
                        status="success"
                        icon={"fa-solid fa-pen-to-square"}
                        type="button"
                        onClick={() => handleUpdateFormTypePopup()}
                      />
                      <Button
                        label="Cancel"
                        title="Cancel"
                        status="secondary"
                        icon={"fa-solid fa-xmark"}
                        type="button"
                        onClick={() => setFormType(1)}
                      />
                    </div>
                  </div>
                )} */}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default React.memo(PublicDefenderRequestForm);
